(function(window, app) {
  "use strict";

  app.router.add({
    menu: ["userMenu"]
  });
})(window, window.app);
